import jsPDF from 'jspdf';
import 'jspdf-autotable';

// Function to draw header for post-delivery challan
const drawHeader = (doc, order, customer, site) => {
  const pageWidth = doc.internal.pageSize.width;
  const centerX = pageWidth / 2;
  const leftMargin = 5;
  const rightMargin = pageWidth - 5;

  // Header at the very top - Center aligned
  doc.setFontSize(9);
  doc.setFont('helvetica', 'bold');
  doc.setTextColor(0, 0, 0); // Black color
  const challanText = 'POST DELIVERY CHALLAN';
  const challanY = 8;
  doc.text(challanText, centerX, challanY, { align: 'center' });

  // Underline the "POST DELIVERY CHALLAN" text
  const challanTextWidth = doc.getTextWidth(challanText);
  doc.setLineWidth(0.3);
  doc.line(
    centerX - (challanTextWidth / 2),
    challanY + 0.5,
    centerX + (challanTextWidth / 2),
    challanY + 0.5
  );

  // GSTIN - Center aligned
  doc.setFontSize(7);
  doc.setFont('helvetica', 'normal');
  doc.text('GSTIN : 27AAIPF9571F1Z1', centerX, 13, { align: 'center' });

  // Mobile and Email on same line - Center aligned
  doc.text('Mob : 9326260161          Email : saiply96@gmail.com', centerX, 17, { align: 'center' });

  // Company name - Large and centered
  doc.setFontSize(14);
  doc.setFont('helvetica', 'bold');
  doc.setTextColor(200, 52, 43); // Red color for company name
  doc.text('SAI PLYWOOD, HARDWARE', centerX, 24, { align: 'center' });
  doc.text('& ALUMINIUM CENTRE', centerX, 30, { align: 'center' });

  // Product description
  doc.setFontSize(6);
  doc.setFont('helvetica', 'normal');
  doc.setTextColor(0, 0, 0);
  const productDesc = 'All Kinds Of Plywood (Greenply, Century, Modak, SP Platinum Kenstar) All Kinds of Wood-CP,';
  const productDesc2 = 'BTC, Salwood, Laminates, Veneers, ACP, Fiber cement board & Aluminum Pipes';
  doc.text(productDesc, centerX, 35, { align: 'center' });
  doc.text(productDesc2, centerX, 38, { align: 'center' });

  // Shop address
  doc.setFontSize(7);
  doc.setFont('helvetica', 'bold');
  const shopAddress = 'Shop No. 10, Nivan Bldg., Plot No. 96, Opp. Podar Int School, Khar (W) Mumbai 400 052.';
  doc.text(shopAddress, centerX, 42, { align: 'center' });

  // Draw horizontal line
  doc.setLineWidth(0.3);
  doc.setDrawColor(0, 0, 0);
  doc.line(leftMargin, 45, rightMargin, 45);

  // Challan details - Left side
  doc.setFontSize(8);
  doc.setFont('helvetica', 'bold');
  doc.setTextColor(0, 0, 128); // Navy blue
  doc.text('DELIVERY', leftMargin, 50);
  doc.text('CHALLAN NO.', leftMargin, 54);

  // Display challan number
  doc.setFont('helvetica', 'normal');
  doc.setTextColor(0, 0, 0);
  doc.text(order.deliveryChallanNumber || order.delivery_challan_number || order.orderNumber || 'N/A', leftMargin + 35, 54);

  // Date - Right side
  doc.setFont('helvetica', 'bold');
  doc.setTextColor(0, 0, 128);
  doc.text('Date :', rightMargin - 35, 50);
  doc.setFont('helvetica', 'normal');
  doc.setTextColor(0, 0, 0);
  const deliveryDate = order.deliveryDate || order.delivery_date || order.updatedAt;
  doc.text(new Date(deliveryDate).toLocaleDateString('en-IN'), rightMargin - 15, 50);

  // Customer name (M/s.) and Site name
  doc.setFontSize(8);
  doc.setFont('helvetica', 'normal');
  doc.text('M/s.', leftMargin, 60);
  doc.setFont('helvetica', 'bold');
  doc.text(customer.name || 'N/A', leftMargin + 12, 60);

  // Add site name below customer name if available
  const siteName = site ? (site.site_name || site.name) : null;
  if (siteName) {
    doc.setFontSize(7);
    doc.setFont('helvetica', 'normal');
    doc.text(`Site: ${siteName}`, leftMargin, 64);
  }

  // Vehicle details - Right side (vertical stack to prevent overflow)
  doc.setFontSize(7);
  doc.setFont('helvetica', 'normal');
  doc.setTextColor(0, 0, 0);

  let vehicleY = 60;
  const vehicleNumber = order.vehicleNumber || order.vehicle_number;
  const driverName = order.driverName || order.driver_name;
  const driverPhone = order.driverPhone || order.driver_phone;

  if (vehicleNumber) {
    doc.text(`Vehicle: ${vehicleNumber}`, rightMargin - 45, vehicleY, { align: 'left' });
    vehicleY += 3;
  }
  if (driverName) {
    doc.text(`Driver: ${driverName}`, rightMargin - 45, vehicleY, { align: 'left' });
    vehicleY += 3;
  }
  if (driverPhone) {
    doc.text(`Ph: ${driverPhone}`, rightMargin - 45, vehicleY, { align: 'left' });
  }
};

// Helper function to format currency
const formatCurrency = (amount) => {
  if (!amount && amount !== 0) return '';
  const num = parseFloat(amount);
  if (isNaN(num)) return '';

  // Split into rupees and paise
  const rupees = Math.floor(num);
  const paise = Math.round((num - rupees) * 100);

  // Format with Indian number system (lakhs/crores)
  const formattedRupees = rupees.toLocaleString('en-IN');

  // Return formatted as "Rs. Ps."
  return `${formattedRupees}.${paise.toString().padStart(2, '0')}`;
};

// Function to calculate totals
const calculateTotals = (items, order) => {
  let subtotal = 0;

  items.forEach(item => {
    const qty = parseFloat(item.deliveredQuantity || item.pendingQuantity || item.quantity) || 0;
    const rate = parseFloat(item.unitPrice) || 0;
    subtotal += qty * rate;
  });

  const transportCharge = parseFloat(order.transportCharge) || 0;
  const loadingUnloadingCharge = parseFloat(order.loadingUnloadingCharge) || 0;

  // Calculate GST item by item (like quotations)
  const isCommon = order.isCommon !== false; // Default to true if not specified
  let itemsGST = 0;
  let chargesGST = 0;

  if (isCommon) {
    // Calculate GST for each item using its individual gst_percentage
    itemsGST = items.reduce((sum, item) => {
      const qty = parseFloat(item.deliveredQuantity || item.pendingQuantity || item.quantity) || 0;
      const rate = parseFloat(item.unitPrice) || 0;
      const itemSubtotal = qty * rate;
      const gstPercentage = parseFloat(item.gstPercentage) || 0;
      return sum + (itemSubtotal * gstPercentage / 100);
    }, 0);

    // Calculate GST on transport and loading charges
    const chargesAmount = transportCharge + loadingUnloadingCharge;
    const loadingGst = parseFloat(order.loadingGst) || 18;
    chargesGST = (chargesAmount * loadingGst) / 100;
  }

  const totalGST = itemsGST + chargesGST;
  const total = subtotal + transportCharge + loadingUnloadingCharge + totalGST;

  return {
    subtotal,
    transportCharge,
    loadingUnloadingCharge,
    itemsGST,
    chargesGST,
    loadingGst: parseFloat(order.loadingGst) || 18,
    totalGST,
    total,
    isCommon
  };
};

// Function to draw item table with rates
const drawItemTable = (doc, order, isLastPage, totals, startSerialNumber) => {
  const leftMargin = 5;
  const tableStartY = 68;

  // Prepare table columns with SR no. on the left
  const columns = [
    { header: 'SR.', dataKey: 'sr' },
    { header: 'PARTICULARS', dataKey: 'particulars' },
    { header: 'QTY.', dataKey: 'quantity' },
    { header: 'RATE', dataKey: 'rate' },
    { header: 'GST %', dataKey: 'gst' },
    { header: 'AMOUNT\nRs.     P.', dataKey: 'amount' }
  ];

  const body = order.items.map((item, index) => {
    const particulars = item.specification
      ? `${item.productName}\n${item.specification}`
      : item.productName;

    const qty = parseFloat(item.deliveredQuantity || item.pendingQuantity || item.quantity) || 0;
    const unit = item.unit || 'pcs';
    const quantityWithUnit = `${qty} ${unit}`;

    const rate = parseFloat(item.unitPrice) || 0;
    const amount = qty * rate;

    // Get GST percentage - only for common orders
    let gstPercentage = 0;
    if (order.isCommon !== false) {
      gstPercentage = parseFloat(item.gstPercentage) || 0;
    }

    return {
      sr: (startSerialNumber + index).toString(),
      particulars: particulars || 'N/A',
      quantity: quantityWithUnit,
      rate: formatCurrency(rate),
      gst: gstPercentage > 0 ? `${gstPercentage}%` : '-',
      amount: formatCurrency(amount)
    };
  });

  // Add summary rows to the body only if this is the last page
  if (isLastPage) {
    // Subtotal
    body.push({
      sr: '',
      particulars: 'Subtotal',
      quantity: '',
      rate: '',
      gst: '',
      amount: formatCurrency(totals.subtotal)
    });

    // Transport and loading charges
    if (totals.transportCharge > 0) {
      body.push({
        sr: '',
        particulars: 'Transport Charge',
        quantity: '',
        rate: '',
        gst: '',
        amount: formatCurrency(totals.transportCharge)
      });
    }

    if (totals.loadingUnloadingCharge > 0) {
      body.push({
        sr: '',
        particulars: 'Loading/Unloading Charge',
        quantity: '',
        rate: '',
        gst: '',
        amount: formatCurrency(totals.loadingUnloadingCharge)
      });
    }

    // GST breakdown (only if isCommon is true)
    if (totals.isCommon && totals.totalGST > 0) {
      if (totals.itemsGST > 0) {
        body.push({
          sr: '',
          particulars: 'GST on Items',
          quantity: '',
          rate: '',
          gst: '',
          amount: formatCurrency(totals.itemsGST)
        });
      }

      if (totals.chargesGST > 0) {
        body.push({
          sr: '',
          particulars: `GST on Charges (${totals.loadingGst}%)`,
          quantity: '',
          rate: '',
          gst: '',
          amount: formatCurrency(totals.chargesGST)
        });
      }

      body.push({
        sr: '',
        particulars: 'Total GST',
        quantity: '',
        rate: '',
        gst: '',
        amount: formatCurrency(totals.totalGST)
      });
    }

    // Grand total
    body.push({
      sr: '',
      particulars: 'GRAND TOTAL',
      quantity: '',
      rate: '',
      gst: '',
      amount: formatCurrency(totals.total)
    });
  }

  doc.autoTable({
    startY: tableStartY,
    margin: { left: leftMargin, right: 5 },
    head: [columns.map(col => col.header)],
    body: body.map(row => columns.map(col => row[col.dataKey])),
    theme: 'grid',
    tableWidth: 'auto',
    pageBreak: 'auto',
    showHead: 'everyPage',
    headStyles: {
      fillColor: [255, 255, 255],
      textColor: [0, 0, 0],
      fontStyle: 'bold',
      halign: 'center',
      fontSize: 8,
      lineWidth: 0.3,
      lineColor: [0, 0, 0],
      cellPadding: 2
    },
    styles: {
      fontSize: 8,
      cellPadding: 2,
      lineWidth: 0.3,
      lineColor: [0, 0, 0],
      overflow: 'linebreak'
    },
    columnStyles: {
      0: { halign: 'center', cellWidth: 8, overflow: 'visible' },
      1: { halign: 'left', cellWidth: 52, overflow: 'linebreak' },
      2: { halign: 'center', cellWidth: 17, overflow: 'visible' },
      3: { halign: 'right', cellWidth: 18, overflow: 'visible' },
      4: { halign: 'center', cellWidth: 12, overflow: 'visible' },
      5: { halign: 'right', cellWidth: 20, overflow: 'visible' }
    },
    didDrawCell: (data) => {
      // Make summary rows bold (only on last page)
      if (isLastPage) {
        const summaryStartIndex = order.items.length;
        if (data.section === 'body' && data.row.index >= summaryStartIndex && data.column.index === 1) {
          data.cell.styles.fontStyle = 'bold';
        }
        // Make TOTAL row extra bold
        if (data.section === 'body' && data.row.index === body.length - 1) {
          data.cell.styles.fontStyle = 'bold';
        }
      }
    }
  });
};

// Function to draw footer
const drawFooter = (doc) => {
  const pageHeight = doc.internal.pageSize.height;
  const pageWidth = doc.internal.pageSize.width;
  const leftMargin = 5;
  const rightMargin = pageWidth - 5;
  const footerY = pageHeight - 15;

  // Add "Received by" section
  const receivedY = footerY - 12;
  doc.setFontSize(7);
  doc.setFont('helvetica', 'normal');
  doc.setTextColor(0, 0, 0);
  doc.text('Received by: __________', leftMargin + 2, receivedY);
  doc.text('Date & Time: __________', leftMargin + 2, receivedY + 5);

  doc.setFontSize(6);
  doc.setFont('helvetica', 'normal');
  doc.text('Taxes as applicable', leftMargin, footerY);
  doc.text('Damaged goods to be returned', leftMargin, footerY + 3);
  doc.text('within 48hrs of delivery', leftMargin, footerY + 6);
  doc.text('Once lifted from the shop not taken back', leftMargin, footerY + 9);

  // Signature section - Right aligned in red
  doc.setFontSize(7);
  doc.setFont('helvetica', 'normal');
  doc.setTextColor(200, 52, 43); // Red color
  doc.text('For Sai Plywood, Hardware &', rightMargin, footerY + 5, { align: 'right' });
  doc.text('Aluminium Centre', rightMargin, footerY + 9, { align: 'right' });
};

export const generatePostDeliveryChallan = (order, customer, site) => {
  // Create PDF in A5 portrait mode (same as one half of the A4 landscape delivery challan)
  // A5 portrait: 148mm x 210mm
  const doc = new jsPDF({
    orientation: 'portrait',
    unit: 'mm',
    format: 'a5'
  });

  const maxItemsPerPage = 10; // Max items per page (including summary)

  // Calculate totals once for all pages
  const totals = calculateTotals(order.items, order);

  // Calculate dynamic summary rows count
  let summaryRowsCount = 2; // Always have Subtotal + GRAND TOTAL
  if (totals.transportCharge > 0) summaryRowsCount++;
  if (totals.loadingUnloadingCharge > 0) summaryRowsCount++;
  if (totals.isCommon && totals.totalGST > 0) {
    if (totals.itemsGST > 0) summaryRowsCount++; // GST on Items
    if (totals.chargesGST > 0) summaryRowsCount++; // GST on Charges
    summaryRowsCount++; // Total GST
  }

  const maxItemsOnLastPage = maxItemsPerPage - summaryRowsCount;
  const minItemsOnLastPage = 2;

  // Split items into chunks
  const totalItems = order.items.length;

  // Calculate pagination
  let itemsPerPage;
  let totalPages;

  if (totalItems <= maxItemsOnLastPage) {
    // All items fit on one page with summary
    itemsPerPage = totalItems;
    totalPages = 1;
  } else {
    // Multiple pages needed
    const itemsBeforeLastPage = totalItems - maxItemsOnLastPage;
    totalPages = Math.ceil(itemsBeforeLastPage / maxItemsPerPage) + 1;

    // Check if last page would have too few items
    const remainingItems = totalItems - (totalPages - 1) * maxItemsPerPage;
    if (remainingItems < minItemsOnLastPage) {
      // Redistribute: reduce items per page to ensure last page has enough
      itemsPerPage = Math.floor((totalItems - minItemsOnLastPage) / (totalPages - 1));
    } else if (remainingItems > maxItemsOnLastPage) {
      // Last page has too many items, add another page
      itemsPerPage = maxItemsPerPage;
    } else {
      itemsPerPage = maxItemsPerPage;
    }
  }

  for (let pageIndex = 0; pageIndex < totalPages; pageIndex++) {
    if (pageIndex > 0) {
      doc.addPage();
    }

    // Calculate item range for this page
    let startIndex, endIndex;

    if (totalPages === 1) {
      // Single page: all items
      startIndex = 0;
      endIndex = totalItems;
    } else if (pageIndex === totalPages - 1) {
      // Last page: remaining items
      startIndex = pageIndex * itemsPerPage;
      endIndex = totalItems;
    } else {
      // Regular page
      startIndex = pageIndex * itemsPerPage;
      endIndex = Math.min(startIndex + itemsPerPage, totalItems);
    }

    const pageItems = order.items.slice(startIndex, endIndex);

    // Create order copy with current page items
    const pageOrder = { ...order, items: pageItems };

    // Check if this is the last page
    const isLastPage = pageIndex === totalPages - 1;

    // Draw header
    drawHeader(doc, pageOrder, customer, site);

    // Draw item table (with summary and rates only on last page)
    // Pass startIndex + 1 for serial number continuation (1-based indexing)
    drawItemTable(doc, pageOrder, isLastPage, totals, startIndex + 1);

    // Draw footer
    drawFooter(doc);
  }

  // Save the PDF
  const fileName = `Post_Delivery_Challan_${order.deliveryChallanNumber || order.orderNumber || 'ORDER'}.pdf`;
  doc.save(fileName);
};
